
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"color",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 22.105c0-.485.186-.97.559-1.34L9.392 12 .559 3.235a1.888 1.888 0 010-2.68 1.922 1.922 0 012.7 0L13.443 10.66c.744.74.744 1.94 0 2.68L3.26 23.446a1.922 1.922 0 01-2.701 0A1.882 1.882 0 010 22.106z","fill":"#A3A3A3"}})])
          )
        }
      }
    